import * as Sentry from '@sentry/react';
import { ENABLE_SENTRY, SENTRY_DSN, SENTRY_ENVIRONMENT } from '@/app-config';

export const initializeSentry = (): void => {
  if (!ENABLE_SENTRY) {
    console.log('ℹ️ Sentry is disabled');
    return;
  }

  if (!SENTRY_DSN) {
    console.warn('⚠️ Sentry DSN not configured');
    return;
  }

  try {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: SENTRY_ENVIRONMENT || 'production',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
    console.log('✅ Sentry initialized successfully');
  } catch (error) {
    console.error('❌ Error initializing Sentry:', error);
  }
};

export const setSentryUser = (user: {
  id: string | number;
  email?: string;
  username?: string;
}): void => {
  if (!ENABLE_SENTRY || !SENTRY_DSN) return;

  Sentry.setUser({
    id: user.id.toString(),
    email: user.email,
    username: user.username,
  });
};

export const clearSentryUser = (): void => {
  if (!ENABLE_SENTRY || !SENTRY_DSN) return;
  Sentry.setUser(null);
};

export const setSentryContext = (
  name: string,
  context: Record<string, unknown>,
): void => {
  if (!ENABLE_SENTRY || !SENTRY_DSN) return;
  Sentry.setContext(name, context);
};

export const captureException = (
  error: Error,
  context?: Record<string, unknown>,
): void => {
  if (!ENABLE_SENTRY || !SENTRY_DSN) {
    console.error('Error captured (Sentry disabled):', error);
    return;
  }

  Sentry.captureException(error, { extra: context });
};

export const captureMessage = (
  message: string,
  level: Sentry.SeverityLevel = 'info',
): void => {
  if (!ENABLE_SENTRY || !SENTRY_DSN) return;
  Sentry.captureMessage(message, level);
};

